export default "__VITE_ASSET__BRXq8vIa__";